<configuration-option-my-work-card></configuration-option-my-work-card>

<employee-booking-config-card></employee-booking-config-card>
<employee-contract-config-card></employee-contract-config-card>
<configuration-option-product-branding-card
  [isCollapsed]="true"
></configuration-option-product-branding-card>
